import { SubProduct } from "./product.model";

export interface IPostSubProduct{
    id?: number;
    allowPaymentOnShipping?: boolean;
    allowDelivery?: boolean;
    deliveryDelay?: string;
    pickFormShop?: boolean;
    description?: string;
    unitDeliveryDuration?: string;
    finalPrice?: number;
    photo?: string;
    photo1?: string;
    photo2?: string;
    title?: string;
    publishedAt?: Date;
    vip?: boolean;
    email?: string;
    username?: string;
    subProductID?: string;
    idSubProduct?: number;
    productID?: string;
    idUser?: number;
    name?: string;
    categoryName?: string;
    firstname?: string;
    lastname?: string;
    price?: number;
    subProduct?: SubProduct;
  }
  
  export class PostSubProduct implements IPostSubProduct{
  
    constructor(
      public id?: number,
      public allowPaymentOnShipping?: boolean,
      public allowDelivery?: boolean,
      public deliveryDelay?: string,
      public pickFormShop?: boolean,
      public description?: string,
      public unitDeliveryDuration?: string,
      public finalPrice?: number,
      public price?: number,
      public photo?: string,
      public photo1?: string,
      public photo2?: string,
      public title?: string,
      public publishedAt?: Date,
      public vip?: boolean,
      public email?: string,
      public username?: string,
      public subProductID?: string,
      public idUser?: number,
      public name?: string,
      public categoryName?: string,
      public firstname?: string,
      public lastname?: string,
      public productID?: string,
      public idSubProduct?: number,
      public subProduct?: SubProduct,
    ) {
      this.id = id;
      this.allowDelivery = allowDelivery;
      this.allowPaymentOnShipping = allowPaymentOnShipping;
      this.deliveryDelay = deliveryDelay;
      this.description = description;
      this.email = email;
      this.finalPrice = finalPrice;
      this.photo = photo;
      this.photo1 = photo1;
      this.photo2 = photo2;
      this.pickFormShop = pickFormShop;
      this.publishedAt = publishedAt;
      this.title = title;
      this.unitDeliveryDuration = unitDeliveryDuration;
      this.username = username;
      this.vip = vip;
      this.subProductID = subProductID;
      this.idUser = idUser;
      this.name = name;
      this.categoryName = categoryName;
      this.firstname = firstname;
      this.lastname = lastname;
      this.productID = productID;
      this.idSubProduct = idSubProduct;
      this.price = price,
      this.subProduct = subProduct;
    }
  
  }
  